import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	type LWApiPublicNetworkDnsDomainTransferCreateIncomingParamsRaw,
	type LWApiPublicNetworkDnsDomainTransferCreateIncomingResultRaw,
} from '@liquidweb-dev/club-sauce/public/network/dns/domain/transfer/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { TRANSFER_LIST_QUERY_KEY } from './useList';

const useCreateIncoming = () => {
	const queryClient = useQueryClient();
	return useMutation<
		LWApiPublicNetworkDnsDomainTransferCreateIncomingResultRaw,
		ApiErrorI,
		LWApiPublicNetworkDnsDomainTransferCreateIncomingParamsRaw
	>({
		mutationFn: (params) =>
			api.network.dns.domain.transfer.apiRaw.createIncoming(params),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [TRANSFER_LIST_QUERY_KEY],
			});
		},
	});
};

export default useCreateIncoming;
